import BaseApi from './base'

class ConfigurationPersComn extends BaseApi {
  constructor() {
    super()
    this.client.defaults.baseURL = `${this.fleetURL}/backoffice`
  }

  getConfigurationPersComns = (query) =>
    this.client.get(`/admin/configuration-file-comm-pers?${query}`)
}

export default new ConfigurationPersComn()
